import { useQuery } from '@tanstack/react-query';
import { getCustomerTransactions } from '../../services/user';
import useUser from '../global/useUser';

function useGetCustomerPayments(customerId: string) {
  const { user } = useUser();

  const {
    data = [],
    isPlaceholderData,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ['customer-payments', customerId, user?.business.id],
    queryFn: async () => {
      const result = getCustomerTransactions(customerId, user?.business.id!);
      return result;
    },
    enabled: !!customerId && !!user?.business.id,
    // disable cache - we always want fresh data
    staleTime: 0,
    gcTime: 0,
  });

  return {
    payments: isPlaceholderData ? [] : data,
    isPlaceholderData,
    isLoading,
    isFetching,
    isError,
    error,
  };
}

export default useGetCustomerPayments;
